<template>
  <div class="payment_info text_left">
    <LoadingOverlay :activeSyncProps="activeSync" :isFullPageProps="true"/>
    <div class="row">
      <div class="contents_area">
        <div class="header_container mb60">
          <div class="txt_subtitle_1 --grey100 text_left">
            Simple pricing
          </div>
          <h3>
            Wonderful experience
          </h3>
        </div>
        <div class="info_layout">
          <InputArea
              ref="inputArea"
              class="input_area"
          />
          <InfoArea
              :selectedTermProps="selectedTermProps"
              :selectedProductProps="selectedProductProps"
              :termProps="termProps"
              :productProps="productProps"
              @doPay="doPay"
              class="info_area"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputArea from './inputArea';
import InfoArea from './infoArea';
import encrypt from "@/common/lib/encrypt";
import _API from '@/api';
import LoadingOverlay from '@/components/loadingOverlay';
import validationMethods from '@/common/lib/validation.js';


export default {
  name: 'PaymentInfo',
  props: {
    selectedTermProps: Object,
    selectedProductProps: Object,
    termProps: Array,
    productProps: Array
  },
  components: {
    InputArea,
    InfoArea,
    LoadingOverlay
  },
  data() {
    return {
      activeSync: false
    }
  },
  created() {
    if (this.selectedProductProps.seqProduct ===  0) {
      this.$router.push('/payments');
    }
  },
  methods: {
    ...encrypt,
    ...validationMethods,
    getPaymentInfo() {
      const paymentInfo = this.$refs.inputArea.getFieldsValue();
      const time = new Date().getTime();

      return {
        cardType : this.checkCardNumValidation(paymentInfo[0].items[0].value),
        cardNumber : this.encryptFunc(paymentInfo[0].items[0].value, time),
        expirationDate : this.encryptFunc(paymentInfo[1].items[0].value, time),
        cardCode : this.encryptFunc(paymentInfo[1].items[1].value, time),
        firstName : paymentInfo[2].items[0].value.trim(),
        lastName : paymentInfo[2].items[1].value.trim(),
        email : paymentInfo[3].items[0].value.trim(),
        zipcode : paymentInfo[3].items[1].value,
        address : paymentInfo[4].items[0].value.trim(),
        time : time,
        seqProduct : this.selectedProductProps.seqProduct,
        paymentType :  this.selectedTermProps.type
      };
    },
    doPay() {
      const pass = this.checkIfNotEntered();
      if (!pass) {return}
      const paramData = this.getPaymentInfo();
      this.activeSync = true
      _API.PAYMENT.checkout(paramData)
      .then(({data}) => {
        if (data.isSuccess) {
          this.$router.push({
            name: 'result',
            params: {
              result: {
                status: 'success',
                data: data.purchaseInfo
              }
            }
          });
        } else {
          this.$router.push({
            name: 'result',
            params: {
              result: {
                status: 'failed',
                data: data
              }
            }
          });
        }
      })
      .finally(() => {
        this.activeSync = false;
      })
    },
    checkIfNotEntered() {
      return this.$refs.inputArea.checkIfNotEntered();
    }
  }
}
</script>
<style lang="scss">

.payment_info {
  overflow-y: auto;
  height: calc(var(--app-height) - 93px);

  .contents_area {

    .info_layout {
      display: flex;

      .input_area {
        width: 50%;
        padding: 35px 70px 70px 0;

        .member_wrap {
          width: 100%;
        }
      }

      .info_area {
        width: 50%;
        padding: 35px;
        background: var(--grey10);
        height: max-content;
      }
    }
  }
}

</style>